export default __webpack_public_path__ + "static/dairy-free-health-3-mobile-444c002a83c0226cf28c520c2308aa94.png";